
import React from 'react';
import { useTranslation } from 'react-i18next';

const TrendingTagsSidebar = () => {
    const { t } = useTranslation();
    // Placeholder data
    const trendingTags = [
        { tag: 'AI', count: 124 },
        { tag: 'Art', count: 98 },
        { tag: 'Philosophy', count: 76 },
        { tag: 'Dreams', count: 54 },
        { tag: 'Technology', count: 45 },
    ];

    return (
        <div className="p-4 bg-gray-800/50 rounded-lg text-white mt-4">
            <h3 className="font-bold text-lg mb-4">{t('trendingTags.title')}</h3>
            <div className="space-y-2">
                {trendingTags.map(item => (
                    <div key={item.tag} className="flex justify-between items-center text-sm p-2 rounded-md hover:bg-gray-700/50 cursor-pointer">
                        <span className="font-semibold text-gray-300">#{item.tag}</span>
                        <span className="text-xs text-gray-400">{item.count} {t('trendingTags.whispers')}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TrendingTagsSidebar;
